import { render, staticRenderFns } from "./MinutesToText.vue?vue&type=template&id=0b2257ea"
import script from "./MinutesToText.js?vue&type=script&lang=js&external"
export * from "./MinutesToText.js?vue&type=script&lang=js&external"
import style0 from "./MinutesToText.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports